import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { Procedimento } from "../../interfaces/entities/Procedimento";
import { Anexo } from "../../interfaces/entities/Reembolso/Anexo";
import { DadosContaBeneficiario } from "../../interfaces/entities/Reembolso/DadosContaBeneficiario";
import { DadosPrestador } from "../../interfaces/entities/Reembolso/DadosPrestador";
import { DadosDependente } from "../../interfaces/entities/Reembolso/Dependentes";
import { Pergunta } from "../../interfaces/entities/Reembolso/Pergunta";
import { ProcedimentoRequest } from '../../interfaces/entities/Reembolso/ProcedimentoRequest';
import { Dados } from "../../interfaces/props/Financeiro/Reembolso/ReembolsoPadrao";
import { Response } from "../../interfaces/services/Response";
import { LstDadosContasCadastradas } from './../../interfaces/entities/Reembolso/DadosContaBeneficiario';

export const getDadosBeneficiarioProdExecutivo = async (): Promise<DadosDependente | null> => {
  try {
    const response = await apiClientes.get('/Reembolso/GetDadosBeneficiarioProdExecutivo', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getReembolsoPadrao = async (): Promise<Dados | null> => {
  try {
    const response = await apiClientes.get('Reembolso/GetReembolsoPadrao', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getLiminarReembolso = async (): Promise<boolean | null> => {
  try {
    const response = await apiClientes.get('Reembolso/GetLiminarReembolso', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data.isLiminar;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const gravarPedidoOuvidorReembolso = async (idPedidoReembolso: string, idUsrContrReembolso: number, numProtocolo: string, dadosPrestador?: DadosPrestador): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/GravarPedidoOuvidorReembolso',
      {
        idPedidoReembolso,
        idUsrContrReembolso,
        numProtocolo,
        idUf: dadosPrestador?.uf,
        idCidade: dadosPrestador?.cidade,
        nomeProfissional: dadosPrestador?.nomePrestador,
        numDocto: dadosPrestador?.numeroDocumento,
        tipoDocto: dadosPrestador?.tipoDocumento,
      },
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getListaProced = async (search: string): Promise<Procedimento[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(
        `/Reembolso/GetListaProcedProdutoExecutivo?descrPesquisa=${search}`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
      );
      if (response.data) {
        resolve(response.data.map((val: any) => ({
          id: parseInt(val.idProced),
          descricao: val.descr
        })));
      } else {
        reject(response);
      }
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const getListaProcedDetalhe = async (id: number): Promise<any | null> => {
  try {
    const response = await apiClientes.get(
      `/Reembolso/GetListaDetalheProcedProdutoExecutivo?idProced=${id}`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );

    return response.data;

  } catch (error: any) {
    return error?.response;
  }
};

export const getFaq = (): Promise<Pergunta[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(
        `/Reembolso/getFAQ`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
      );

      if (response?.data) {
        resolve(
          response.data.map((v: any) => ({
            title: v.titulo || '',
            text: v.texto || '',
          }
          )));
      } else {
        reject(response);
      }
    } catch (error: any) {
      reject(error)
    }
  })

};

export const getRegrasDoReembolso = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Reembolso/GetRegrasDoReembolso',
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

export const getsolicitacoesprodutoexecutivo = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(
      `/Reembolso/getsolicitacoesprodutoexecutivo`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );

    return response;

  } catch (error: any) {
    return error?.response;
  }
}

export const gravaDadosContaReembolso = async (dadosConta: LstDadosContasCadastradas, idUsrContr: string, idPessoaDependente: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/GravaDadosContaReembolso', {
      indClassifConj: dadosConta.indClassifConj,
      nomeTitularConta: dadosConta.nomeTitularConta,
      cpfTitularConta: dadosConta.cpfTitularConta,
      banco: dadosConta.numBanco,
      agencia: dadosConta.agencia,
      numConta: `${dadosConta.numConta}-${dadosConta.digConta}`  ,
      indTipoConta: dadosConta.indTipoConta,
      idCadContaReembolso: dadosConta.idCadContaReembolso,
      idPessoaDependente,
      idUsrContr
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const excluirContaReembolso = async (dadosConta: LstDadosContasCadastradas): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/ExcluirContaReembolso', {
      idCadContaReembolso: dadosConta.idCadContaReembolso,
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}


export const getdadosrevisaoprodutoexecutivo = async (id: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(
      `/Reembolso/getdadosrevisaoprodutoexecutivo?idPedidoReembolso=${id}`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );

    return response;

  } catch (error: any) {
    return error?.response;
  }
};

export const getAnexoReembolso = async (idPedido: string, idArquivo: string): Promise<{ base64: string, nome: string }> => {
  try {
    const response = await apiClientes.get(
      `/Reembolso/getAnexoReembolso?idPedidoReembolso=${idPedido}&idArquivoReembolso=${idArquivo}`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );

    if (response?.data?.anexoBase64 && response?.data?.descr) {
      return {
        base64: response.data.anexo,
        nome: response.data.descr
      }
    } else {
      throw Error("Sem informações suficientes no arquivo.");
    }

  } catch (error: any) {
    return error?.response;
  }
};

export const gravarresppendenciaouvidorreembolso = async (idPedidoReembolso: number, novoVlr: number, obs: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/gravarresppendenciaouvidorreembolso', {
      idPedidoReembolso: idPedidoReembolso.toString(),
      novoVlr,
      obs
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });

    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const gravaarquivospedidoreembolso = async (idPedidoReembolso: number, anexos: Array<Anexo>): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/gravaarquivospedidoreembolso', {
      idPedidoReembolso: idPedidoReembolso.toString(),
      lstArquivos: anexos
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });

    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getDadosContaBeneficiarioProdutoExecutivo = async (idUsrContr: number): Promise<DadosContaBeneficiario | null> => {
  try {
    const response = await apiClientes.get('Reembolso/GetDadosContaBeneficiarioProdutoExecutivo', {
      params: { idUsrContr },
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getInformacoesPrestador = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('Reembolso/GetInformacoesPrestador', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getUf = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`Reembolso/GetUF`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getCidades = async (idUf: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`Reembolso/GetCidades/?idUf=${idUf}`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const gravaPedidoReembolso = async (
  emailContato: string, telContato: string, idCadContaReembolso: string, idUsrContrSolicit: string,
  motivo: string, idPedidoReembolso: string, vlrTotal?: number, novoVlr?: number
): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/GravaPedidoReembolso',
      {
        emailContato,
        idCadContaReembolso,
        idUsrContrSolicit,
        telContato,
        vlrTotal,
        idPedidoReembolso,
        motivo,
        novoVlr
      }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const getListaProcedReembolso = async (descrPesquisa: string, idPedidoReembolso: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('Reembolso/GetListaProcedRembolso', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { 
        descrPesquisa, 
        idPedidoReembolso,
        start: '0',
        limit: '49',
      }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const inclurProcedimentos = async (motivo: string, idPedidoReembolso: string, listaProcedimentos: ProcedimentoRequest[]): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/IncluirProcedimentos', {
      motivo,
      idPedidoReembolso,
      listaProcedimentos
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const retornaTermoReembolso = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('Reembolso/RetornaTermoReembolso', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: {}
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const cancelaPedidoReembolso = async (idPedidoReembolso: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('Reembolso/CancelaPedidoReembolso', {
      idPedidoReembolso
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
}

export const prestadorCredenciado = async (docIdentificacao:string): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('Reembolso/PrestadorCredenciado', {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
        params: {docIdentificacao}
      });
      resolve(response?.data);
    } catch (error: any) {
      console.log({ error });
      reject(error?.response?.data?.mensagem || '');
    }
  })
  
}

export const getReembolsoPagoPdf = async (dataInicio: string, dataFim: string): Promise<any> => {
  try {
    const response = await apiClientes.get('Reembolso/GetReembolsoPagoPdf', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { dtInic: dataInicio, dtFim: dataFim }
    });
  
    if (response?.data) {
      return response.data;
    }
  } catch (err: any) {
    throw err?.response?.data;
  }
}

